<!--
  CustomerTagsFilter renders a filter with dropdown tag options and reads/writes
  from the `tag` URL query param. Possible tag values are populated from the
  store.
  Note: this version is adapted to work with the customer API by using `tag` instead of `tags`.
-->

<script>
import { mapState } from 'vuex';
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';

export default {
  components: {
    iFilter,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  computed: {
    ...mapState(['tags']),
    tagOptions() {
      return this.tags.list.map((t) => ({ label: t.value }));
    },
    value() {
      const { tag } = this.params;
      if (!tag) {
        return [];
      }
      if (typeof tag === 'string') {
        return [tag];
      }
      return tag;
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(updated) {
      const updatedValues = updated.selection.map((t) => t.label);
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          tag: updatedValues.length === 0 ? undefined : updatedValues.join(','),
        },
      });
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.CUSTOMERS_SEARCH_CLICKED, {
        itemName: 'tags-filter',
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Tags"
    data-testid="customer-tags-filter"
    data-dd-action-name="customers-view-tags-filter"
    :options="tagOptions"
    :model-value="value"
    @selection-changed="onSelectionChanged"
  />
</template>
